(function() {
  // variables
  const SG_SELECTOR = '#cart_form .add_to_cart.global-button--primary';
  const mainVariantId = getSelectedVariantId();
  // if (!mainVariantId) throw new Error('No variant selected.');

  const simpleGuaranteeGid = window.simpleGuaranteeConfig?.variantId;
  const simpleGuaranteeNumeric = toNumericId(simpleGuaranteeGid);
  
  // --- utils ---
  // simpleGuaranteeNumeric: the numeric variant id to remove (e.g., 1234567890)
  async function removeSimpleGuaranteeIfPresent(simpleGuaranteeNumeric) {
    // console.log(simpleGuaranteeNumeric)
    try {
      // 1) Load cart
      const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!cartRes.ok) throw new Error(`Cart fetch failed: ${cartRes.status}`);
      const cart = await cartRes.json();

      // 2) Collect all matching lines (may be multiple if properties differ)
      const targets = cart.items.filter((item) => Number(item.variant_id) === Number(simpleGuaranteeNumeric));
      if (!targets.length) {
        // console.log('No Simple Guarantee lines found.');
        return;
      }

      // 3) Remove all by line key (quantity: 0)
      await Promise.all(
        targets.map((line) =>
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ id: line.key, quantity: 0 }),
          }).then((res) => {
            if (!res.ok) throw new Error(`Remove failed for ${line.key}: ${res.status}`);
          })
        )
      );
      // console.log(`Removed ${targets.length} Simple Guarantee line(s).`);
      
      window.upcartRefreshCart();

    } catch (err) {
      console.error('Error removing Simple Guarantee lines:', err);
    }
  }

  // async function refreshCartDrawer() {
  //   fetch('/?sections=cart-drawer')
  //     .then((response) => response.json())
  //     .then((sections) => {
  //       console.log(sections)
  //       const parser = new DOMParser();
  //       const html = parser.parseFromString(sections['cart-drawer'], 'text/html');
  //       console.log(html);
  //       const newDrawer = html.querySelector('#CartPopup');

  //       // Replace the existing drawer content
  //       const cartDrawer = document.querySelector('#CartPopup');
  //       if (cartDrawer && newDrawer) {
  //         cartDrawer.innerHTML = newDrawer.innerHTML;
  //       }
  //     })
  //     .catch((err) => console.error('Error refreshing cart drawer:', err));
  // }


  function toNumericId(idOrGid) {
    if (!idOrGid) return null;
    const s = String(idOrGid);
    if (s.startsWith('gid://')) {
      const m = s.match(/\/(\d+)$/);
      return m ? m[1] : null;
    }
    // strip non-digits just in case
    return s.replace(/\D+/g, '') || null;
  }

  function getSelectedVariantId() {
    // Read current variant ID from the standard hidden input (no form binding)
    const input = document.querySelector('input[name="id"]');
    return input ? toNumericId(input.value) : null;
  }

  // --- binding ---
  document.addEventListener('DOMContentLoaded', () => {
    removeSimpleGuaranteeIfPresent(simpleGuaranteeNumeric);
  });
})();